import SkeletonBase from "newui/components/Skeleton";
import { useOverallScores } from "../../hooks/useOverallScores";
import { SupplierAwardCard } from "./SupplierAwardCard";
import { getLeaderInviteId, getLeaderScore, isBelowThreshold } from "./utils";

interface PreviewScoresViewProps {
  rfxId: number;
  evalId: number;
}

export const PreviewScoresView: React.FC<PreviewScoresViewProps> = ({
  rfxId,
  evalId,
}) => {
  const { data: overallData, isLoading, isError } = useOverallScores(rfxId, evalId);

  if (isLoading) {
    return (
      <div className="space-y-3" data-testid="preview-scores-view-loading">
        {[1, 2, 3].map((i) => (
          <SkeletonBase
            key={i}
            startColor="lightgray"
            width="100%"
            height="80px"
            className="!rounded-lg"
          />
        ))}
      </div>
    );
  }

  if (isError || !overallData) {
    return (
      <p className="text-sm text-red-600" data-testid="preview-scores-view-error">
        Failed to load scores.
      </p>
    );
  }

  const suppliers = overallData.suppliers;
  const leaderId = getLeaderInviteId(suppliers);
  const leaderScore = getLeaderScore(suppliers, leaderId);
  const hasConsensus = suppliers.some((s) => s.consensus_weighted_total !== null);

  return (
    <div className="space-y-3" data-testid="preview-scores-view">
      {!hasConsensus && (
        <div className="rounded-md bg-amber-50 border border-amber-200 px-3 py-2 text-xs text-amber-700">
          No consensus scoring has occurred. Showing pre-meeting weighted averages.
        </div>
      )}
      {suppliers.map((supplier) => (
        <SupplierAwardCard
          key={supplier.invite_id}
          supplier={supplier}
          awardStatus="pending"
          comment=""
          isLeader={supplier.invite_id === leaderId}
          isBelowThreshold={isBelowThreshold(supplier, leaderScore)}
          showAwardControls={false}
          onAwardStatusChange={() => undefined}
          onCommentChange={() => undefined}
        />
      ))}
    </div>
  );
};
